export { useAccessRightsTabEffects } from './useAccessRightsEffects';
export { useAccessRightsList } from './useAccessRightsList';
export { useAccessRightsTemplates } from './useAccessRightsTemplates';
